import { DIS } from '@typings/dis';

export const isClubRotaract = (clubType: string) =>
  clubType === DIS.ClubTypeEnum.RotaractClub;
